/* focus */
button[data-share-button],
dialog.preem input {
  --tw-ring-color: var(--ember-brand);

  &:focus-visible, &:focus {
    outline: 2px solid transparent;
    outsilen-offset: 2px;
    border-color: transparent;
  }
  &:focus {
    --tw-ring-offset-shadow:
        var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-shadow:
        var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
      box-shadow:
        var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  }
}

dialog.preem {
  .error {
    border: 2px solid #622;
    border-radius: 0.25rem;
    padding: 0.25rem;
    background: #fee;
  }
}


button[data-share-button] {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-property: all;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  padding: 0.25rem 0.5rem;
  /**
  * TODO: can this be nested automatically?
  */
  border-radius: 0.25rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}


.preem__tip {
  --tw-bg-opacity: 1;
  padding: 1rem;
  background: white;
  background: rgb(240 249 255 / var(--tw-bg-opacity));
  color: rgb(50, 60, 100);
  position: relative;
  border-radius: 0.25rem;

  .preem__tip__bulb {
    position: absolute;
    left: 1rem;
    top: 1rem;
    text-shadow: 1px 2px 1px rgba(0,0,0,0.2);
    font-size: 1.5rem;
  }
  .preem__tip__text {
    padding-left: 2rem;
    padding-right: 1.5rem;
  }
}
dialog.preem {
  width: 100dvw;
  background: transparent;
  display: flex;
  justify-content: center;
  overflow: hidden;

  animation: var(--animation-slide-in-up), var(--animation-fade-in);
  animation-timing-function: var(--ease-out-5);
  animation-duration: 0.2s;

  &:focus-visible, &:focus {
    outline: none;
  }

  &:focus-visible .modal-facade, &:focus .modal-facade {
    outline: 2px solid transparent;
    outsilen-offset: 2px;
    border-color: transparent;
  }
  &:focus .modal-facade {
    --tw-ring-offset-shadow:
        var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
      --tw-ring-shadow:
        var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
      box-shadow:
        var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  }

  > .modal-facade {
    background: white;
    border-radius: 0.25rem;
    width: max-content;
  }
}
dialog.preem::backdrop {
  backdrop-filter: blur(1px);
}
dialog.preem header {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  align-items: center;
  border-bottom: 1px solid #333;
}
dialog.preem h2 {
  margin: 0 !important;
}

dialog.preem main {
  padding: 2rem;
  padding-bottom: 1rem;
  max-width: 500px;
  display: grid;
  gap: 1rem;

  .field {
    display: grid;
    gap: 0.5rem;
    input {
      width: 100%;
    }
    .field-input {
      display: flex;
      gap: 0.5rem;
    }
  }
  input {
    padding: 0.25rem 0.5rem;
    border: 1px solid #333;
    border-radius: 0.25rem;
    color: #444;
  }
}

dialog.preem form {
}
dialog.preem .inline-mini-form {
  display: grid;
  align-items: end;
  grid-auto-flow: column;
  grid-template-columns: 1fr min-content;

  [type="submit"] {
    margin-left: 0.5rem;
  }
}

dialog.preem footer,
dialog.preem form {
  button {
    color: white;
    border-radius: 0.25rem;
    padding: 0.25rem 0.5rem;
   background: var(--code-bg);
    border: 1px solid var(--horizon-border);

    &.cancel {
      color: black;
      background: #eee;
      border-color: #aaa;
    }
  }

  button:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width)
      var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width))
      var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  }

  button:focus-visible {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  button:hover {
    opacity: 0.9;
  }
}

dialog.preem footer {
  padding: 1rem 2rem;

  .right {
    display: grid;
    justify-content: end;
  }

  .buttons {
    display: flex;
    gap: 1rem;
  }
}

